/** The camelCase shape `oauthConsent.getConsentInfo`/`approve`/`deny` expect. */
export interface OAuthConsentParams {
  clientId: string;
  redirectUri: string;
  responseType: string;
  codeChallenge: string;
  codeChallengeMethod: string;
  scope: string;
  state?: string;
  /** The OpenID Connect nonce: the server puts it in the id_token. */
  nonce?: string;
}

/**
 * Reads the OAuth-standard (snake_case) query params that `/oauth/authorize` forwards onto this
 * page and translates them into the camelCase shape the `oauthConsent` tRPC router expects.
 * Returns `null` when any required param is missing, so the caller can render an ErrorView
 * instead of sending a malformed request to the server.
 */
export function parseOAuthConsentParams(searchParams: URLSearchParams): OAuthConsentParams | null {
  const clientId = searchParams.get('client_id');
  const redirectUri = searchParams.get('redirect_uri');
  const responseType = searchParams.get('response_type');
  const codeChallenge = searchParams.get('code_challenge');
  const codeChallengeMethod = searchParams.get('code_challenge_method');
  const scope = searchParams.get('scope');
  const state = searchParams.get('state');
  const nonce = searchParams.get('nonce');

  if (
    clientId === null ||
    redirectUri === null ||
    responseType === null ||
    codeChallenge === null ||
    codeChallengeMethod === null ||
    scope === null
  ) {
    return null;
  }

  return {
    clientId,
    redirectUri,
    responseType,
    codeChallenge,
    codeChallengeMethod,
    scope,
    ...(state !== null ? { state } : {}),
    ...(nonce !== null ? { nonce } : {}),
  };
}
